<template>
  <div
    v-if="status !== 'accept'"
    class="is-fixed is-bottom is-flex has-items-left pad-single"
  >
    <div
      class="has-border pad-single border-thin border-is-grey-light rounded-md bg-white p-5 text-slate-600 shadow-sm"
    >
      <p class="is-copy paragraph">
        🍪 We use cookies to make your experience on this website better.
      </p>
      <div class="is-flex buttons has-items-right">
        <button
          class="button is-success pad-left pad-right rounded-md"
          @click="accept"
        >
          Accept
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
const isServer = import.meta.env.SSR

const statusKey = 'cookie-acceptance-status'
const status = ref('accept')

onMounted(() => {
  status.value = getCookieStatus()
})

function getCookieStatus() {
  if (!isServer) {
    const status = localStorage.getItem(statusKey)
    if (status === 'accept') return 'accept'
    return 'declined'
  }
}

function setCookieStatus(type) {
  if (!isServer) {
    localStorage.setItem(statusKey, type)
  }
}

function accept() {
  setCookieStatus('accept')
  status.value = 'accept'
}

function decline() {
  setCookieStatus('decline')
}
</script>
